import { validateMassLEData } from "actions/CarrierAgreementMgmt/LeasedEquipment";
import { useMutation } from "react-query";

const useValidateData = () => {
  return useMutation(validateMassLEData);
};

export default useValidateData;
